import { Circle, Polygon } from 'react-leaflet';
import * as L from 'leaflet';
import { Feature, Geometry } from 'geojson';
import GeofenceTooltip from '../../tooltips/geofence-tooltip/GeofenceTooltip';
import { GeofenceProperties } from '@casops/store/apis/geofencesApi';

const StrokeRegularWeight = 2;
const StrokeRegularOpacity = 1;
export const FillRegularOpacity = 0.2;
export const FillHoverOpacity = 0.4;
export const GeofenceRegularColor = '#3388FF';

export const commonPathDisplay: L.PathOptions = {
  color: GeofenceRegularColor,
  weight: StrokeRegularWeight,
  opacity: StrokeRegularOpacity,
  fillColor: GeofenceRegularColor,
  fillOpacity: FillRegularOpacity,
};

export interface GeofenceLayerProps {
  feature: Feature<Geometry, GeofenceProperties>;
  pathOptions?: L.PathOptions;
}

export function GeofenceLayer({
  feature: { geometry, properties },
  pathOptions = commonPathDisplay,
}: GeofenceLayerProps) {
  if (geometry.type === 'Polygon') {
    const coords = L.GeoJSON.coordsToLatLngs(geometry.coordinates, 1, L.GeoJSON.coordsToLatLng);

    return (
      <Polygon positions={coords} {...pathOptions}>
        <GeofenceTooltip properties={properties} />
      </Polygon>
    );
  } else if (
    geometry.type === 'Point' &&
    typeof properties?.radius === 'number' &&
    geometry.coordinates.length >= 2
  ) {
    const centre = L.GeoJSON.coordsToLatLng([geometry.coordinates[0], geometry.coordinates[1]]);

    return (
      <Circle center={centre} radius={properties.radius} {...pathOptions}>
        <GeofenceTooltip properties={properties} />
      </Circle>
    );
  }

  return null;
}

export default GeofenceLayer;
